import {
  CAN_ADD_EMPLOYEE,
  CAN_ADD_SCHEDULE,
  CAN_VIEW_BTN_MAKE_CALL,
  CAN_VIEW_BTN_SEND_NOTIFICATION,
  CAN_VIEW_BTN_START_SETTLING,
  CAN_VIEW_CHECKBOX_CHOOSE_ALL,
  CAN_VIEW_TOOLTIP_TRANSFER_INTO_OPERATION,
} from './actionPermissions';
import { CAN_EDIT_OVP_DATE } from 'features/DeliveryScheduleDetail/permissions';

import { ROLES } from 'types';

export const getPermissions = {
  [ROLES.COMMERCIAL]: [CAN_ADD_SCHEDULE, CAN_ADD_EMPLOYEE],

  [ROLES.PRIME_CONTRACTOR]: [
    CAN_ADD_EMPLOYEE,
    CAN_ADD_SCHEDULE,
    CAN_VIEW_BTN_MAKE_CALL,
    CAN_VIEW_BTN_SEND_NOTIFICATION,
    CAN_VIEW_CHECKBOX_CHOOSE_ALL,
    CAN_VIEW_TOOLTIP_TRANSFER_INTO_OPERATION,
    CAN_EDIT_OVP_DATE,
  ],

  [ROLES.HOUSING_CONTRACTOR]: [
    CAN_VIEW_BTN_MAKE_CALL,
    CAN_VIEW_CHECKBOX_CHOOSE_ALL,
    CAN_EDIT_OVP_DATE,
  ],

  [ROLES.ENGINEERING_NETWORKS]: [
    CAN_ADD_EMPLOYEE,
    CAN_ADD_SCHEDULE,
    CAN_VIEW_TOOLTIP_TRANSFER_INTO_OPERATION,
  ],

  [ROLES.HEAD_EN]: [CAN_ADD_SCHEDULE, CAN_ADD_EMPLOYEE, CAN_VIEW_TOOLTIP_TRANSFER_INTO_OPERATION],

  [ROLES.HEAD_OVP]: [CAN_ADD_SCHEDULE, CAN_ADD_EMPLOYEE],

  [ROLES.PARTNER]: [CAN_ADD_SCHEDULE, CAN_ADD_EMPLOYEE],

  [ROLES.FURNISHING_SUPERVISOR]: [
    CAN_ADD_EMPLOYEE,
    CAN_ADD_SCHEDULE,
    CAN_VIEW_BTN_MAKE_CALL,
    CAN_VIEW_BTN_SEND_NOTIFICATION,
  ],

  [ROLES.SUPERVISOR]: [
    CAN_ADD_EMPLOYEE,
    CAN_ADD_SCHEDULE,
    CAN_VIEW_BTN_START_SETTLING,
    CAN_VIEW_TOOLTIP_TRANSFER_INTO_OPERATION,
  ],
};
